import { PropsWithChildren } from 'react';
import { AdaptiveContext, IAdaptiveProvider } from './AdaptiveContext';
import { mockGetChatsResponse } from '../../data/mockData';

const MockAdaptiveProviderValue: IAdaptiveProvider = {
    chatInfo: {
        persona: '',
        version: undefined,
        build: undefined,
        setPersona: () => {},
    },
    chatHistory: {
        items: mockGetChatsResponse,
        set: () => {},
        reload: () => Promise.resolve(),
        isLoading: false,
    },
    catalogFavorites: {
        personas_pinned: [''],
        prompts_pinned: [''],
        firstFavorite: '',
        disallowPinning: false,
        toggleFavorite: async (favorite: string) => {},
        toggleFavoritePrompt: async (favorite: string) => {},
        setFavorites: async () => {},

        personas_disable_auto_pin: [],
        setAsFavoriteOnInitialPrompt: () => {},
        swapPinnedPersonas: async (fromKey: string, toKey: string) => {},
    }
};

const MockAdaptiveProvider: React.FC<PropsWithChildren> = ({ children }) => {
    return <AdaptiveContext.Provider value={MockAdaptiveProviderValue}>
        {children}
    </AdaptiveContext.Provider>;
};

export default MockAdaptiveProvider;
